import { render, staticRenderFns } from "./TrafficRequestContextTemplate.vue?vue&type=template&id=9859a3dc&scoped=true"
import script from "./TrafficRequestContextTemplate.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestContextTemplate.vue?vue&type=script&lang=ts"
import style0 from "./TrafficRequestContextTemplate.vue?vue&type=style&index=0&id=9859a3dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9859a3dc",
  null
  
)

export default component.exports